import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const SettingsContext = createContext({
  settings: null,
  currency: { code: "USD", symbol: "$", label: "US Dollar" },
  currencies: [],
  refresh: () => {},
});

// Module-level cache of last known currency symbol so formatMoney works
// even outside React tree (toasts etc).
let _activeSymbol = "$";
export function getActiveCurrencySymbol() {
  return _activeSymbol;
}

export function formatMoney(value, symbol) {
  const s = symbol || _activeSymbol || "$";
  const n = Number(value || 0);
  return `${s}${n.toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
}

export function SettingsProvider({ children, authed }) {
  const [settings, setSettings] = useState(null);
  const [currencies, setCurrencies] = useState([]);

  const refresh = useCallback(async () => {
    if (!authed) return;
    try {
      const [s, c] = await Promise.all([
        api.get("/settings"),
        api.get("/currencies"),
      ]);
      setSettings(s.data);
      setCurrencies(c.data || []);
    } catch { /* silent */ }
  }, [authed]);

  useEffect(() => { refresh(); }, [refresh]);

  const currency = (() => {
    const code = settings?.currency || "USD";
    const found = currencies.find((c) => c.code === code);
    const out = found || { code, symbol: "$", label: code };
    _activeSymbol = out.symbol;
    return out;
  })();

  return (
    <SettingsContext.Provider value={{ settings, currency, currencies, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
